module.exports = {
  getWrapBehavior: require('./get-wrap-behavior'),
  wrapBehavior: require('./wrap-behavior')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/event/index.js
// module id = 202
// module chunks = 0